import 'twin.macro';

import { ArrowLeft } from '@cheqroom/icons';
import { FC, ReactNode } from 'react';

import { IconButton } from '../../IconButton/IconButton';
import { Skeleton } from '../../Skeleton/Skeleton';
import { Stack } from '../../Stack/Stack';
import { StyledHeader, StyledHeaderContent, StyledMinimalHeader } from './Header.styles';

interface HeaderProps {
	actions?: ReactNode;
	banner?: ReactNode;
	breadcrumbs?: ReactNode;
	footer?: ReactNode;
	children?: ReactNode;
	minimal?: boolean;
	onBack?: () => void;
	borderless?: boolean;
	responsive?: boolean;
	loading?: boolean;
}

const Header: FC<HeaderProps> = ({
	actions,
	banner = null,
	breadcrumbs,
	footer,
	children,
	minimal,
	onBack,
	borderless = false,
	responsive = true,
	loading = false,
}) => {
	if (minimal) {
		return (
			<StyledMinimalHeader borderless={borderless}>
				{children}
				{actions}
			</StyledMinimalHeader>
		);
	}

	return (
		<StyledHeader borderless={borderless}>
			{banner}
			<StyledHeaderContent responsive={responsive}>
				<Stack tw="min-w-0 max-w-full" vertical justify="between" spacing="loose">
					{loading ? <Skeleton width="100px" height="21px" /> : breadcrumbs}
					{(children || onBack) && (
						<Stack align="center" spacing="loose">
							{onBack && (
								<IconButton
									variation="secondary"
									aria-label="Back"
									onClick={onBack}
									source={ArrowLeft}
								/>
							)}

							{children}
						</Stack>
					)}
				</Stack>

				{loading ? <Skeleton width="105px" height="38px" /> : actions}
			</StyledHeaderContent>
			{footer}
		</StyledHeader>
	);
};

export default Header;
